import React, { Component } from 'react'
import { Row, Col } from 'react-bootstrap'
import i18next from 'i18next'
import GridContainer from './GridContainer'
import Wopi360TargetForm from './Wopi360TargetForm'
import OrderCreditsModal from './OrderCreditsModal'
import NoMoreCredits from './NoMoreCredits'
import Credits from './Credits'

import adminStyles from './styles/admin.scss'

export default class Wopi360TargetCreate extends Component {
  state = {
    orderModalActive: false
  }

  componentDidMount() {
    this.props.getUnits(this.props.currentOrganisationId)
  }

  handleSave = (
    givenName,
    familyName,
    email,
    organisation,
    role,
    deadlineAt,
    language,
    unitUuids,
    isManager,
    canInvite,
    message
  ) => {
    this.props.onCreate(
      this.props.currentOrganisationId,
      givenName,
      familyName,
      email,
      organisation,
      role,
      deadlineAt,
      language,
      isManager,
      canInvite,
      message,
      unitUuids
    )
  }

  handleDismissNoMoreCredits = e => {
    e.preventDefault()

    this.props.onDismissNoMoreWopiCredits()
  }

  handleOrderCreditsOpen = e => {
    e.preventDefault()

    this.setState({
      orderModalActive: true
    })
  }

  handleOrderCreditsClose = e => {
    e.preventDefault()

    this.setState({
      orderModalActive: false
    })
  }

  render() {
    const { currentLanguage, currentOrganisation, noMoreWopiCredits, units } = this.props

    const credits = currentOrganisation.organisation.creditsWopi360

    return (
      <GridContainer>
        <OrderCreditsModal
          isModalVisible={this.state.orderModalActive}
          handleClose={this.handleOrderCreditsClose}
        />

        {noMoreWopiCredits && <NoMoreCredits handleDismiss={this.handleDismissNoMoreCredits} />}

        <div className={adminStyles.app}>
          <Row>
            <Col md={12}>
              <header>
                <h1>{i18next.t('open_new_wopi360_target')}</h1>

                <Credits
                  product="wopi360"
                  credits={credits}
                  handleOrder={this.handleOrderCreditsOpen}
                />
              </header>

              <Wopi360TargetForm
                currentLanguage={currentLanguage}
                unitSuggestions={units ? units.toArray() : []}
                onSave={this.handleSave}
                saveText={i18next.t('continue')}
                cancelTo="/wopi360"
                hideUnits
              />
            </Col>
          </Row>
        </div>
      </GridContainer>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Wopi360TargetCreate.js